import React, { useEffect, useState } from "react";
import TableSkeleton from "../../../../../../../../component/TableSkeleton";
import { Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import { useOutletContext, useNavigate } from "react-router";
import EmptyState from "../../../../../../../../component/EmptyState";
import { headCellSx, bodyCellSx } from "../../../../../../../../component/listing";
import { getPayslipsByEmployee } from "../../../../../../../../services/payroll";
import { tokens } from "../../../../../../../../theme";
import { money, periodLabel } from "../../../../payroll-new/payrollUtils";

const ProfilePayslips = () => {
  const [, employeeId] = useOutletContext();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!employeeId) return;
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const res = await getPayslipsByEmployee(employeeId);
        if (active) setRows(Array.isArray(res?.data) ? res.data : []);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [employeeId]);

  if (loading) return (
          /* The header and the column widths are known before the data
             is, so they render immediately and nothing shifts when the
             rows land. */
          <Table sx={{ width: "100%", tableLayout: "fixed" }}>
            <TableHead>
        <TableRow>
          <TableCell sx={headCellSx}>Period</TableCell>
          <TableCell align="right" sx={headCellSx}>Gross</TableCell>
          <TableCell align="right" sx={headCellSx}>Deductions</TableCell>
          <TableCell align="right" sx={headCellSx}>Net Pay</TableCell>
        </TableRow>
      </TableHead>
            <TableBody><TableSkeleton columns={4} /></TableBody>
          </Table>
        );
  if (rows.length === 0) return <EmptyState title="No payslips" description="No payslips generated for this employee yet." />;

  return (
    <Table sx={{ width: "100%", tableLayout: "fixed" }}>
      <TableHead>
        <TableRow>
          <TableCell sx={headCellSx}>Period</TableCell>
          <TableCell align="right" sx={headCellSx}>Gross</TableCell>
          <TableCell align="right" sx={headCellSx}>Deductions</TableCell>
          <TableCell align="right" sx={headCellSx}>Net Pay</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((p) => (
          <TableRow key={p._id} hover onClick={() => navigate(`/app/settings/payroll/payslip/${p._id}`)}
            sx={{ cursor: "pointer", "&:hover": { background: tokens.surfaceSubtle } }}>
            <TableCell sx={{ ...bodyCellSx, fontWeight: 600 }}>{periodLabel(p.month, p.year)}</TableCell>
            <TableCell align="right" sx={{ ...bodyCellSx, color: tokens.textMuted }}>{money(p.grossPay)}</TableCell>
            <TableCell align="right" sx={{ ...bodyCellSx, color: tokens.danger }}>{money(p.totalDeductions)}</TableCell>
            <TableCell align="right" sx={{ ...bodyCellSx, fontWeight: 600 }}>{money(p.netPay)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ProfilePayslips;
